module.exports = __webpack_public_path__ + "img/qrcode_bg.4615642f.png";